module.exports = __webpack_public_path__ + "img/qiandao.ebef3b26.png";